/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelWebMenuItem.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "common/web-menu-item";

export class AutogenModelWebMenuItem<RowType extends ModelRow> extends Endpoint<RowType, RowWebMenuItemFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowWebMenuItem extends ModelRow<RowWebMenuItemFields> {
	constructor(values?: Partial<RowWebMenuItemFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowWebMenuItemFields {
	caption: string;
	class_name: string;
	company_id: string;
	company_type: string;
	favorite_caption: string;
	id: string;
	ide_only: string;
	local_only: string;
	mcleod_only: string;
	path: string;
	visible: string;
}
